import React from 'react';
import logo from '../assets/images/logo.png';
import dogFootprint from '../assets/images/stamp.png';

const SplashScreen = () => {
  // 足跡の個数（例：5個）
  const footprintCount = 5;
  const footprintsArray = Array.from({ length: footprintCount }, (_, index) => index);

  return (
    <div className="splash-screen">
      {/* グラデーションリング付きロゴ */}
      <div className="logo-container">
        <img src={logo} alt="Pet Direct Hospital Logo" className="splash-logo" />
      </div>
      <p className="splash-title">Pet Direct Hospital</p>
      <p className="splash-subtitle">โรงพยาบาลสัตว์เพ็ทไดเร็ค • ทองหล่อ 20</p>
      <div className="footprints">
        {footprintsArray.map((index) => (
          <img
            key={index}
            src={dogFootprint}
            alt=""
            className="footprint"
            style={{
              // 左から右へ均等に配置（例：10% からスタート、20%刻み）
              left: `${10 + index * 20}%`,
              // 0.4秒ずつ順次表示
              animationDelay: `${index * 0.4}s`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default SplashScreen;
